module.exports = __webpack_public_path__ + "static/media/lepes8.f7a669e1.png";